<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Informasi Layanan</div>
        </div>
        <div id="appCapsule">
            <div class="section inset mt-2">
                <div class="p-1" style="font-size: 12px; line-height: 150%">
                    <h3>Syarat dan Ketentuan Layanan</h3>
                    <ol>
                        <li>
                            Layanan Transfer ke Rekening adalah layanan yang
                            dapat mitra gunakan untuk melakukan pengiriman uang
                            dari saldo {{ VUE_ENV.VUE_APP_NAME }} ke rekening
                            bank.
                        </li>
                        <li>
                            {{ VUE_ENV.VUE_APP_NAME }} bukan sebagai
                            Penyelenggara Jasa Pembayaran (PJP).
                        </li>
                        <li>
                            {{ VUE_ENV.VUE_APP_NAME }} menggunakan layanan jasa
                            pihak ke 3 sebagai phak pengirim dana, seperti :
                            <ul>
                                <li>
                                    PT FLIPTECH LENTERA INSPIRASI PERTIWI (FLIP)
                                </li>
                                <li>
                                    PT EASTERN TRANSGLOBAL REMITTANCE (BRICK)
                                </li>
                            </ul>
                        </li>
                        <li>
                            Biaya Layanan dapat berubah sewaktu-waktu tanpa
                            pemeberitahuan sebelumnya.
                        </li>
                        <li>
                            Pengiriman dana umumnya akan terproses otomatis
                            kurang dari 1 (satu) menit atau mengikuti keadaan
                            normal bank.
                        </li>
                        <li>
                            Jika terjadi gangguan pada pihak ke-3 atau bank
                            terkait saat pengirman dana dilakukan dan
                            menyebabkan transaksi menjadi terhambat, maka proses
                            pengecekan dan penanganan akan dilakukan maksimal
                            H+4 dihari kerja atau mengikuti waktu rekonsiliasi
                            dari pihak bank bank terkait.
                        </li>
                        <li>
                            Dilarang menggunakan layanan ini untuk melakukan
                            tindakan yang dilarang oleh negara seperti pencucian
                            uang dan pendanaan terorisme.
                        </li>
                        <li>
                            Pihak {{ VUE_ENV.VUE_APP_NAME }} berhak melakukan
                            tindakan yang di anggap perlu kepada mitra jika
                            ditemukan adanya dugaan pelanggaran ketentuan
                            layanan ini.
                        </li>
                        <li>
                            Dengan menggunakan layanan ini, mitra setuju dengan
                            syarat dan ketentuan layanan yang berlaku dan siap
                            menerima segala resiko yang akan terjadi dikemudian
                            hari.
                        </li>
                    </ol>

                    <h3>Nominal dan Limit Transfer</h3>
                    <table
                        class="table table-sm"
                        style="font-size: 11px; line-height: 1rem"
                    >
                        <tr>
                            <td width="50%">Minimal Nominal</td>
                            <td style="text-align: right; font-weight: bold">
                                Rp 10.000
                            </td>
                        </tr>
                        <tr>
                            <td>Maksimal Nominal</td>
                            <td style="text-align: right; font-weight: bold">
                                Rp 2.500.000
                            </td>
                        </tr>
                        <tr>
                            <td>Total Limit Harian</td>
                            <td style="text-align: right; font-weight: bold">
                                Rp 20.000.000
                            </td>
                        </tr>
                        <tr>
                            <td>Limit Transfer ke No. Rekening yang sama</td>
                            <td style="text-align: right; font-weight: bold">
                                2x / Hari
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingContent: true,
            };
        },
        created() {
            setTimeout(() => (this.loadingContent = false), 500);
        },
        computed: {
            ...mapState(['VUE_ENV']),
        },
    };
</script>
